<template>
    <!-- 票券管理－新增编辑详情页 -->
    <content-view>
        <div class="wrap-container-in">
            <a-form :form="form">
                <!-- <a-form-item label="每日预约上限" :label-col="{span: 4}" :wrapper-col="{span: 10}">
                    <a-input-number v-decorator="['stockNum', {rules: [{required: true, message: '请输入'}]}]" placeholder="请输入" />
                </a-form-item> -->
                <a-form-item required label="预约说明" :label-col="{span: 4}" :wrapper-col="{span: 10}">
                    <rich-text :showImg="false" ref="reserveNoticeContent" :list="reserveNoticeContent"></rich-text>
                    <!-- <rich-text-viewer :list="contentList"></rich-text-viewer> -->
                </a-form-item>
                <a-form-item required label="入园提醒" :label-col="{span: 4}" :wrapper-col="{span: 10}">
                    <rich-text :showImg="false" ref="comeinNoticeContent" :list="comeinNoticeContent"></rich-text>
                    <!-- <rich-text-viewer :list="contentList"></rich-text-viewer> -->
                </a-form-item>
            </a-form>
            <div class="btn-bar text-right">
                <a-button :loading="submitLoading" @click="$router.back()">取消</a-button>
                <a-button :loading="submitLoading" type="primary" @click="submit">确定</a-button>
            </div>
        </div>
    </content-view>
</template>

<script type="text/javascript">
    import { mapGetters } from "vuex";
    import richText from '@/components/modules/rich-text.component'
    import richTextViewer from '@/components/modules/rich-text-viewer.component'
    export default {
        name: "editReserve",
        components: {
            richText,
            richTextViewer
        },
        props: {},
        data() {
            return {
                submitLoading: false,
                reserveNoticeContent: [],
                comeinNoticeContent: [],
            };
        },
        computed: {
            ...mapGetters(["shopId",'shopName'])
        },
        watch: {
            shopId() {
                this.thirdReserveGet()
            }
        },
        methods: {
            /**
             * @submit 提交
             */
            submit() {
                if (this.submitLoading) {
                    return false;
                }
                this.submitLoading = true;
                this.form.validateFieldsAndScroll({force: true}, (errors, values) => {
                    if (errors) {
                        this.submitLoading = false;
                        return false;
                    }
                    values.id = this.id;
                    values.shopId = this.shopId;
                    values.shopName = this.shopName;
                    values.reserveNoticeContent = JSON.stringify(this.$refs.reserveNoticeContent.getData());
                    values.comeinNoticeContent = JSON.stringify(this.$refs.comeinNoticeContent.getData());
                    this.$api.changeCode.thirdReserveSave({
                        body: values
                    }).then(res => {
                        this.submitLoading = false;
                        this.$message.success('操作成功！');
                        this.$router.back();
                    }).catch(err => {
                        this.submitLoading = false;
                    });
                });
            },
            thirdReserveGet() {
                if(!this.shopId) return
                this.$api.changeCode.thirdReserveGet({
                    body: {
                        shopId: this.shopId,
                        pageNum: 1,
                        pageSize: 9999,
                    }
                }).then(res => {
                    let valueForm = {
                        stockNum: res.stockNum
                    }

                    this.reserveNoticeContent = JSON.parse(res.reserveNoticeContent);
                    this.comeinNoticeContent = JSON.parse(res.comeinNoticeContent);
                    this.id = res.id;
                    this.$nextTick(()=> {
                        this.form.setFieldsValue(valueForm);
                    })
                }).catch(err => {
                    
                });
            },
        },
        beforeCreate() {
            this.form = this.$form.createForm(this);
        },
        created() {},
        mounted() {
            this.thirdReserveGet();
        },
        beforeDestroy() {},
    };
</script>
<style lang="scss">
</style>
